(() => {
  const selectionSelector = '[data-kfa-material-selection]';
  const accordionSelector = '[data-kfa-material-accordion]';
  const HOVER_DELAY = 520;
  const SWITCH_FADE = 360;
  const XPOSURE_FRAME_SELECTOR = '.variant-option--kfa-xposure-frame';
  const XPOSURE_FORMAT_SELECTOR = '.variant-option--kfa-xposure-format';
  const XPOSURE_FRAME_OPEN_DELAY = 180;
  const XPOSURE_FRAME_CLOSE_DELAY = 420;

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setOpen(accordion, open, options = {}) {
    if (!accordion) return;
    const panel = accordion.querySelector('[data-kfa-material-panel]');
    if (!panel) return;
    accordion.dataset.open = open ? 'true' : 'false';
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    accordion.querySelectorAll('[data-kfa-material-toggle]').forEach((control) => {
      control.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (control.classList.contains('kfa-material-accordion__toggle')) {
        control.setAttribute('aria-label', open ? accordion.dataset.closeLabel : accordion.dataset.openLabel);
      }
    });
    if (open && options.focusPanel) panel.focus?.();
  }

  function currentLanguage(accordion) {
    return accordion.dataset.language || 'en';
  }

  function setLanguage(accordion, language, animate = true) {
    if (!accordion) return;
    const oldLanguage = currentLanguage(accordion);
    const oldPane = accordion.querySelector(`[data-kfa-language-content="${oldLanguage}"]`);
    const newPane = accordion.querySelector(`[data-kfa-language-content="${language}"]`);
    if (!newPane) return;

    accordion.dataset.language = language;
    accordion.querySelectorAll('[data-kfa-language]').forEach((button) => {
      const active = button.dataset.kfaLanguage === language;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    if (oldPane === newPane) return;
    const panel = accordion.querySelector('[data-kfa-material-panel]');
    const shouldAnimate = animate && !reducedMotion() && accordion.dataset.open === 'true';

    if (!shouldAnimate) {
      accordion.querySelectorAll('[data-kfa-language-content]').forEach((pane) => {
        pane.hidden = pane !== newPane;
        pane.classList.remove('is-entering', 'is-leaving');
      });
      return;
    }

    const startHeight = panel.getBoundingClientRect().height;
    panel.style.height = `${startHeight}px`;
    oldPane?.classList.add('is-leaving');

    window.setTimeout(() => {
      if (oldPane) {
        oldPane.hidden = true;
        oldPane.classList.remove('is-leaving');
      }
      newPane.hidden = false;
      newPane.classList.add('is-entering');
      const endHeight = newPane.scrollHeight;
      requestAnimationFrame(() => {
        panel.style.height = `${endHeight}px`;
        requestAnimationFrame(() => newPane.classList.remove('is-entering'));
      });
      window.setTimeout(() => { panel.style.height = ''; }, 760);
    }, SWITCH_FADE);
  }

  function setFormProperty(form, name, value) {
    if (!form) return;
    let input = form.querySelector(`input[data-kfa-line-property="${CSS.escape(name)}"]`);
    if (!value) {
      input?.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.dataset.kfaLineProperty = name;
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.value = value;
  }

  function updateCartProperties(productId, item) {
    if (!productId || !item) return;
    document
      .querySelectorAll(`product-form-component[data-product-id="${CSS.escape(String(productId))}"] form`)
      .forEach((form) => {
        setFormProperty(form, 'ATELI’R Material', item.dataset.material || '');
        setFormProperty(form, 'ATELI’R Finish', item.dataset.finishLabelEn || '');
        setFormProperty(
          form,
          'Signature Finish',
          item.dataset.signature === 'true' ? 'Yes' : ''
        );
      });
  }

  function update(productId, variantId) {
    if (!variantId) return;
    document.querySelectorAll(selectionSelector).forEach((selection) => {
      if (productId && selection.dataset.productId !== String(productId)) return;
      const item = selection.querySelector(`[data-kfa-material-variant][data-variant-id="${CSS.escape(String(variantId))}"]`);
      if (!item) return;
      updateCartProperties(selection.dataset.productId, item);
      const intro = selection.querySelector('[data-kfa-material-intro]');
      const tagline = selection.querySelector('[data-kfa-material-tagline]');
      const size = selection.querySelector('[data-kfa-material-size]');
      if (intro) intro.textContent = item.dataset.intro || '';
      if (tagline) tagline.textContent = item.dataset.tagline || '';
      if (size) size.textContent = item.dataset.size || '';

      document.querySelectorAll(accordionSelector).forEach((accordion) => {
        if (accordion.dataset.productId !== selection.dataset.productId) return;
        const mappings = [
          ['[data-kfa-accordion-tagline]', item.dataset.tagline],
          ['[data-kfa-accordion-species]', item.dataset.species],
          ['[data-kfa-accordion-story]', item.dataset.story],
          ['[data-kfa-accordion-reason]', item.dataset.reason],
          ['[data-kfa-accordion-finish]', item.dataset.finish],
          ['[data-kfa-accordion-archive]', item.dataset.archive],
        ];
        mappings.forEach(([selector, value]) => {
          const target = accordion.querySelector(selector);
          if (target) target.textContent = value || '';
        });

        const finishChapter = accordion.querySelector('[data-kfa-accordion-finish-chapter]');
        if (finishChapter) finishChapter.hidden = !(item.dataset.finish || '').trim();
      });
    });
  }


  function setXposureFramePickerOpen(fieldset, open) {
    if (!fieldset) return;
    fieldset.dataset.kfaFrameOpen = open ? 'true' : 'false';
    const trigger = fieldset.querySelector('[data-kfa-xposure-frame-trigger]');
    trigger?.setAttribute('aria-expanded', String(open));
  }

  function revealXposureMaterialFor(fieldset) {
    const picker = fieldset.closest('variant-picker');
    const productId = picker?.dataset.productId;
    if (!productId) return;

    document.querySelectorAll(`${selectionSelector}[data-product-id="${CSS.escape(String(productId))}"]`).forEach((selection) => {
      selection.hidden = false;
      selection.dataset.kfaXposureSelectionPending = 'false';
    });

    document.querySelectorAll(`${accordionSelector}[data-product-id="${CSS.escape(String(productId))}"]`).forEach((accordion) => {
      if (!accordion.classList.contains('kfa-material-accordion--xposure')) return;
      accordion.hidden = false;
      accordion.dataset.kfaXposureAccordionPending = 'false';
      setLanguage(accordion, currentLanguage(accordion), false);
      setOpen(accordion, true);
    });
  }


  function setXposureFormatPickerOpen(fieldset, open) {
    if (!fieldset) return;
    fieldset.dataset.kfaFormatOpen = open ? 'true' : 'false';
    fieldset.querySelector('[data-kfa-xposure-format-trigger]')?.setAttribute('aria-expanded', String(open));
  }

  function initialiseXposureFormatPicker(fieldset) {
    if (!fieldset || fieldset.dataset.kfaFormatInitialised === 'true') return;
    fieldset.dataset.kfaFormatInitialised = 'true';
    setXposureFormatPickerOpen(fieldset, false);

    let openTimer = null;
    let closeTimer = null;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const trigger = fieldset.querySelector('[data-kfa-xposure-format-trigger]');

    const open = () => {
      window.clearTimeout(closeTimer);
      setXposureFormatPickerOpen(fieldset, true);
    };
    const close = () => {
      window.clearTimeout(openTimer);
      if (fieldset.matches(':focus-within')) return;
      setXposureFormatPickerOpen(fieldset, false);
    };

    if (finePointer.matches) {
      fieldset.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(open, XPOSURE_FRAME_OPEN_DELAY);
      });
      fieldset.addEventListener('mouseleave', () => {
        window.clearTimeout(openTimer);
        closeTimer = window.setTimeout(close, XPOSURE_FRAME_CLOSE_DELAY);
      });
    }

    trigger?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setXposureFormatPickerOpen(fieldset, fieldset.dataset.kfaFormatOpen !== 'true');
    });

    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        window.setTimeout(() => setXposureFormatPickerOpen(fieldset, false), 440);
      });
    });
  }

  function initialiseXposureFramePicker(fieldset) {
    if (!fieldset || fieldset.dataset.kfaFrameInitialised === 'true') return;
    fieldset.dataset.kfaFrameInitialised = 'true';
    setXposureFramePickerOpen(fieldset, false);

    let openTimer = null;
    let closeTimer = null;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const trigger = fieldset.querySelector('[data-kfa-xposure-frame-trigger]');

    const open = () => {
      window.clearTimeout(closeTimer);
      setXposureFramePickerOpen(fieldset, true);
    };
    const close = () => {
      window.clearTimeout(openTimer);
      if (fieldset.matches(':focus-within')) return;
      setXposureFramePickerOpen(fieldset, false);
    };

    if (finePointer.matches) {
      fieldset.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(open, XPOSURE_FRAME_OPEN_DELAY);
      });
      fieldset.addEventListener('mouseleave', () => {
        window.clearTimeout(openTimer);
        closeTimer = window.setTimeout(close, XPOSURE_FRAME_CLOSE_DELAY);
      });
    }

    trigger?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setXposureFramePickerOpen(fieldset, fieldset.dataset.kfaFrameOpen !== 'true');
    });

    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        revealXposureMaterialFor(fieldset);
        window.setTimeout(() => setXposureFramePickerOpen(fieldset, false), 540);
      });
    });
  }

  function initialiseAccordion(accordion) {
    if (!accordion || accordion.dataset.kfaInitialised === 'true') return;
    accordion.dataset.kfaInitialised = 'true';
    accordion.dataset.language = accordion.dataset.language || 'en';
    setLanguage(accordion, accordion.dataset.language, false);
    setOpen(accordion, false);

    let hoverTimer;
    const header = accordion.querySelector('.kfa-material-accordion__header');
    if (header && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      header.addEventListener('mouseenter', () => {
        if (accordion.dataset.open === 'true') return;
        hoverTimer = window.setTimeout(() => setOpen(accordion, true), HOVER_DELAY);
      });
      header.addEventListener('mouseleave', () => window.clearTimeout(hoverTimer));
    }

    accordion.querySelectorAll('[data-kfa-material-toggle]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(accordion, accordion.dataset.open !== 'true');
      });
    });

    accordion.querySelectorAll('[data-kfa-language]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const language = button.dataset.kfaLanguage;
        if (accordion.dataset.open !== 'true') {
          setLanguage(accordion, language, false);
          setOpen(accordion, true);
        } else {
          setLanguage(accordion, language, true);
        }
      });
    });
  }

  function initialise(root = document) {
    root.querySelectorAll(selectionSelector).forEach((selection) => {
      update(selection.dataset.productId, selection.dataset.initialVariantId);
    });
    root.querySelectorAll(accordionSelector).forEach(initialiseAccordion);
    root.querySelectorAll(XPOSURE_FORMAT_SELECTOR).forEach(initialiseXposureFormatPicker);
    root.querySelectorAll(XPOSURE_FRAME_SELECTOR).forEach(initialiseXposureFramePicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();

  document.addEventListener('variant:update', (event) => {
    update(event.detail?.data?.productId, event.detail?.resource?.id);
  });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
